
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  // Set by AuthGuard when it sends the user back here
  unauthorized = false;
  accessCheckFailed = false;

  constructor(private authService: AuthService, route: ActivatedRoute) {
    this.unauthorized = route.snapshot.queryParamMap.get('unauthorized') === 'true';
    this.accessCheckFailed = route.snapshot.queryParamMap.get('error') === 'access-check-failed';
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }
}